<template>
  <StellaFeatureHint
    v-if="!isOrgMember"
    :enabled="shouldGetTheCartFeatureHint"
    hintId="global-cart-hint"
    name="global-cart-hint"
    content="Add items to your cart from any project and any store to keep them somewhere safe for the days / weeks / months you deliberate. Easily buy from the cart whenever you’re ready."
    title="NEW! Your multi-store cart"
    position="bottom"
    type="info"
  >
    <StellaTooltip text="Cart">
      <StellaButton
        type="ghost"
        size="sm"
        class="!sm<:px-2"
        @click="openGlobalCart"
        v-track="'Global Cart Clicked'"
        v-track-props="{ component: 'Top Nav' }"
      >
        <StellaIcon icon="cart" size="md" />
        <transition name="bounce">
          <div
            v-if="cartItemsCount"
            :key="cartItemsCount"
            class="absolute top-0 right-0 w-min min-w-3 px-0.5 rounded-full bg-green-30 text-green-90 grid items-center"
          >
            <StellaText type="Label XXXS">{{ cartItemsCount }}</StellaText>
          </div>
        </transition>
      </StellaButton>
    </StellaTooltip>
  </StellaFeatureHint>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useAppSidePanelState } from '/@/App/appSidePanelState'
import differenceInDays from 'date-fns/esm/fp/differenceInDays'
import { useCurrentDesigner } from '/@/data/designer/current'
import { useCartData } from '../../globalCart/api'

const { designer, isOrgMember } = useCurrentDesigner()
const { metadata } = useCartData()
const appSidePanelState = useAppSidePanelState()
function openGlobalCart() {
  appSidePanelState.cartOpened = !appSidePanelState.cartOpened
}

const shouldGetTheCartFeatureHint = computed(() => {
  const d = designer.value
  if (!d?.activeSince) return false
  if (differenceInDays(new Date(d.activeSince), new Date()) < 7) return false
  return true
})

const cartItemsCount = computed(() => {
  const stats = metadata.value?.statuses
  if (!stats) return 0
  let tot = 0
  for (const stat of stats) {
    if (stat.status === 'APPROVED') {
      if (stat.projectThingType === 'PRODUCT') {
        tot += stat.count
      }
    }
  }

  return tot
})
</script>

<style>
.bounce-enter-active,
.bounce-leave-active {
  transition:
    transform 0.2s ease-in-out,
    color 0.2s ease-in-out;
}

.bounce-enter-from {
  transform: scale(1.5);
}
.bounce-leave-to {
  transform: scale(1.5);
  color: transparent !important;
}
</style>
